module.exports = __webpack_public_path__ + "3f570f72e0970ae4658fd50410d51ef1.MP3";